<template>
  <div>
    <div class="overlayLoader" v-if="loader">
      <md-progress-spinner
        :md-diameter="100"
        class="md-accent spinner-postion"
        :md-stroke="7"
        md-mode="indeterminate"
      ></md-progress-spinner>
    </div>
    <!-- <div style="margin-bottom: 10px; margin-left: 15px; color: red;">
      <label for="" v-if="locationId === null"
        >Please select Location to save or edit bid</label
      >
    </div> -->
    <div>
      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 md-size-15">
          <md-field>
            <label for="font">RFP Number</label>
            <md-input
              v-model="rfpHdrDetails.rfp_number"
              :title="rfpHdrDetails.rfp_number"
              disabled
            >
            </md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-25">
          <md-field>
            <label for="font">Descrption</label>
            <md-input
              v-model="rfpHdrDetails.description"
              :title="rfpHdrDetails.description"
              disabled
            >
            </md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-15">
          <md-field>
            <label>Start Date</label>
            <md-input
              v-model="rfpHdrDetails.start_date"
              :title="rfpHdrDetails.start_date"
              disabled
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-15">
          <md-field>
            <label>End Date</label>
            <md-input
              v-model="rfpHdrDetails.end_date"
              :title="rfpHdrDetails.end_date"
              disabled
            ></md-input>
          </md-field>
        </div>
        <!-- <div class="md-layout-item md-small-size-100 md-size-15">
          <md-field>
            <b-icon
              icon="pin-map-fill"
              aria-hidden="true"
              style="margin-top: -20px; font-size: 20px; color: #EB3573"
              v-if="locationId === null"
              class="icon"
              :class="{ 'icon-animate': animate }"
            ></b-icon>
            <label for="filter" class="text-black mandatory">Location</label>
            <md-input
              v-model="rfpHdrDetails.location"
              :title="rfpHdrDetails.location"
              readonly
              @click="showHideLocationDetails(true)"
            ></md-input>
          </md-field>
        </div> -->
        <!-- <div class="md-layout-item md-small-size-100 md-size-15">
          <md-field>
            <label>Version</label>
            <md-input
              v-model="rfpHdrDetails.version"
              :title="rfpHdrDetails.version"
              readonly
              disabled
            ></md-input>
          </md-field>
        </div> -->
        <div style="margin-top: 20px; display: flex;" v-if="excluded">
          <b-form-checkbox
            v-model="excluded"
            :value="true"
            disabled
            :unchecked-value="false"
            style="display: inline"
          >
          </b-form-checkbox>
          <div>Excluded</div>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-15">
          <md-field>
            <label>Bid Status</label>
            <md-input
              v-model="rfpHdrDetails.bidStatus"
              :title="rfpHdrDetails.bidStatus"
              readonly
              disabled
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-15">
          <md-field>
            <label>Retention</label>
            <md-input
              v-model="rfpHdrDetails.retention"
              :title="rfpHdrDetails.retention"
              readonly
              disabled
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-25">
          <md-field>
            <label>Payment Terms</label>
            <md-input
              v-model="rfpHdrDetails.paymentTerms"
              :title="rfpHdrDetails.paymentTerms"
              readonly
              disabled
            ></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-25">
          <!-- <md-field>
            <label class="mandatory">Supplier Terms</label>
            <md-input v-model="supplierTerms" :title="supplierTerms"></md-input>
          </md-field> -->
          <label for="supplierTerms" class="mandatory" style="color: grey;"
            >Payment Terms Acceptance</label
          >
          <div style="margin-top: -10px;">
            <md-radio
              v-model="supplierTerms"
              value="Yes"
              :disabled="rfpHdrDetails.bidStatus === 'SUBMIT'"
              @change="checkPaymentTermsAcceptance('Yes')"
              >Yes</md-radio
            >
            <md-radio
              v-model="supplierTerms"
              value="No"
              :disabled="rfpHdrDetails.bidStatus === 'SUBMIT'"
              @change="checkPaymentTermsAcceptance('No')"
              >No</md-radio
            >
          </div>
        </div>
        <div class="md-layout-item md-small-size-100 md-size-50">
          <md-field>
            <label class="mandatory">Supplier Payment Terms</label>
            <md-input
              v-model="supplierPaymentTerms"
              :title="supplierPaymentTerms"
              :disabled="
                supplierTerms === 'Yes' ||
                  supplierTerms === null ||
                  rfpHdrDetails.bidStatus === 'SUBMIT'
              "
              maxlength="100"
            ></md-input>
          </md-field>
        </div>
        <div>
          <b-button
            style="border: none; background-color: teal; color: white; cursor: pointer; padding: 6px 30px; margin-top: 5px;"
            @click="uploadExcel()"
            >UPLOAD DOCUMENT</b-button
          >
        </div>
        <div>
          <!-- <md-button
            v-if="rfpHdrDetails.bidStatus !== 'SUBMIT'"
            @click="getOpenKmAuthenticateUploadDocument()"
            class="md-raised md-rose"
            :disabled="
              rfpHdrDetails.bidStatus === null || rfpHdrDetails.bidStatus === ''
            "
            >Upload Bid Document</md-button
          >
          <md-button
            v-if="rfpHdrDetails.bidStatus === 'SUBMIT'"
            @click="getOpenKmAuthenticateUploadDocument()"
            class="md-raised md-rose"
            >View Bid Document</md-button
          > -->
        </div>
        <br />
        <div>
          <b-button
            style="border: none; background-color: green; color: white; padding: 6px 30px; margin-top: 5px; margin-left: 5px;"
            @click="openReviewModal()"
            >REVIEW & SUBMIT</b-button
          >
        </div>
        <div>
          <b-button
            style="border: none; background-color: green; color: white; padding: 6px 30px; margin-top: 5px; margin-left: 2px; cursor: pointer;"
            @click="openQnAModal(true)"
            >Q & A</b-button
          >
        </div>
        <div v-if="awardFlag">
          <b-button
            style="border: none; background-color: teal; color: white; padding: 6px 30px; margin-top: 5px; margin-left: 2px; cursor: pointer;"
            @click="openCloseAwardModal(true)"
            >PO Award</b-button
          >
        </div>
        <!-- <div
          class="md-layout-item md-small-size-100 md-size-15"
          style="margin-left: 30px;"
        >
          <md-button
            class="md-raised md-primary search-btn"
            @click="excludeLocationRowSelected()"
            :disabled="locationId === null"
            >{{ excluded ? "Include Location" : "Exclude Location" }}</md-button
          >
        </div> -->
        <!-- <div
          v-if="rfpHdrDetails.bidStatus === 'SUBMIT'"
          class="md-layout-item md-small-size-100 md-size-10"
          style="margin-left: -50px;"
        >
          <md-button
            :disabled="editMode || locationId === null"
            class="md-raised md-primary search-btn"
            @click="alterEditBidMode()"
            >Edit Bid</md-button
          >
        </div> -->
        <!-- <div
          class="md-layout-item md-small-size-100 md-size-10"
          style="margin-left: -20px;"
        >
          <md-button
            class="md-raised md-primary search-btn"
            @click="getOpenKmAuthenticate('attachment')"
            :disabled="locationId === null"
          >
            View Attachment</md-button
          >
        </div> -->
        <div
          class="md-layout-item md-small-size-100 md-size-15"
          style="margin-left: 15px;"
        ></div>
      </div>
    </div>
    <div style="display: flex;">
      <div
        style="padding: 0px 10px;margin-top: 5px; width: 40%; border: 1px solid grey"
        v-if="showDocumentModal"
      >
        <p style="font-weight: bold; margin-left: 10px;">Header Attachments</p>
        <uploadDocument
          style="margin-top: -20px;"
          :wfHdrId="documentId"
          :openKmAuth="openKmAuth"
          :propMenuId="menuSubmenuRfpHeader.menuId"
          :PropSubMenuId="menuSubmenuRfpHeader.submenuId"
          :approval_status="poHeaderDetails.approval_status"
          formName="rfpBoq"
        />
      </div>
      <div
        style="padding: 0px 10px;margin-top: 5px; width: 40%; border: 1px solid grey"
        v-if="showDocumentModal"
      >
        <p style="font-weight: bold; margin-left: 10px;">BOQ Attachments</p>
        <uploadDocument
          style="margin-top: -20px;"
          :wfHdrId="rfpHdrDetails.rfp_header_id"
          :openKmAuth="openKmAuthBoqExcel"
          :propMenuId="menuSubmenuBoqExcel.menuId"
          :PropSubMenuId="menuSubmenuBoqExcel.submenuId"
          :approval_status="poHeaderDetails.approval_status"
          formName="rfpBoq"
        />
      </div>
      <div
        style="padding: 0px 10px;margin-top: 5px; width: 40%; border: 1px solid grey"
        v-if="showDocumentModal"
      >
        <p style="font-weight: bold; margin-left: 10px;">Terms & Conditions</p>
        <uploadDocument
          :wfHdrId="termId"
          :openKmAuth="openKmAuth"
          :propMenuId="menuSubmenuTermsAndCondition.menuId"
          :PropSubMenuId="menuSubmenuTermsAndCondition.submenuId"
          :approval_status="poHeaderDetails.approval_status"
          formName="rfpTnc"
        />
      </div>
    </div>
    <!-- <div>
      <label for="">Select Location</label>
      <div style="border: 2px solid grey; padding: 10px">
        <b-table
          striped
          hover
          bordered
          outlined
          sticky-header
          :items="rpfLocationData"
          :fields="rpfLocationField"
          show-empty
          class="bg-white"
        >
          <template #cell(select)="data">
            <b-form-radio
              :key="data.index"
              name="esc-radios"
              :value="data.index"
              v-model="locationSelected"
              @change="locationRowSelected(data.item)"
            ></b-form-radio>
          </template>
          <template #cell(copy_bid)="data">
            <md-button class="md-raised md-warning search-btn"
            :disabled="locationSelected !== data.index || data.item.bid_loc_status === 'NOT SAVED'"
            @click="showHideLocations(true)"
              >Copy Bid</md-button
            >
          </template>
        </b-table>
      </div>
    </div> -->
    <!-- <div>
      <md-button class="md-rose" @click="downloadExcelData()"
        >Download Excel</md-button
      >
    </div> -->
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <!-- <md-card> -->
      <div>
        <b-table
          striped
          hover
          bordered
          outlined
          sticky-header
          :items="rpfLineBoqData"
          :fields="rpfLineBoqField"
          show-empty
          class="bg-white"
        >
          <template #cell(long_desc)="data">
            <span style="cursor:context-menu;" :title="data.item.long_desc">{{
              truncateComment(data.item.long_desc, 35)
            }}</span>
          </template>
          <template #head(unit_price)="">
            <label for="filter">Unit Price</label>
          </template>
          <template #cell(unit_price)="data">
            <md-field>
              <md-input
                type="number"
                :disabled="!editMode || excluded || locationId === null"
                v-model="data.item.unit_price"
                @change="qtyTwoDecimalValue(data.index)"
                @input="
                  checkUnitPriceApplicable(data.item.unit_price, data.index)
                "
              ></md-input>
            </md-field>
          </template>
          <template #cell(remarks)="data">
            <md-field>
              <md-input
                :disabled="!editMode || excluded || locationId === null"
                v-model="data.item.remarks"
              ></md-input>
            </md-field>
          </template>
          <template #cell(attribute)="data">
            <md-button
              :disabled="!data.item.boq_bid_id"
              class="md-raised md-warning search-btn"
              @click="showHideAttributeDetails(true, data.item)"
              >Add Attribute</md-button
            >
          </template>
          <!-- <template #head(exclude_boq)="data">
            <div>
              <b-form-checkbox
                v-model="excludeAllBoqs"
                :value="true"
                :unchecked-value="false"
                style="display: inline"
                
                @change="selectAllExcludedBoq($event)"
              >
              </b-form-checkbox>
              <span>{{ data.label }}</span>
            </div>
          </template> -->
          <template #cell(include_boq)="data">
            <b-form-checkbox
              v-model="data.item.include_boq"
              :value="true"
              :unchecked-value="false"
              style="display: inline"
              disabled
            >
            </b-form-checkbox>
          </template>
          <template #cell(price)="data">
            <md-button
              @click="showHidePriceModal(true, data.item)"
              class="md-raised md-warning search-btn"
              >Price</md-button
            >
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="fill"
          size="sm"
          class="my-0"
        ></b-pagination>
        <div
          v-if="rpfLineBoqData.length && totalRows <= perPage"
          class="pagination-count"
        ></div>
      </div>
    </div>
    <b-modal
      v-model="showAttributeDetails"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Attribute Details"
      @hidden="hideAttributepDetails()"
    >
      <div class="md-layout-item">
        <b-table
          style="max-height:400px;"
          striped
          hover
          outlined
          sticky-header
          :items="attributeData"
          :fields="attributeField"
          show-empty
          class="bg-white"
        >
          <template #cell(rating)="data">
            <md-field style="min-height: auto;">
              <md-input v-model="data.item.rating" v-numericOnly></md-input>
            </md-field>
          </template>
          <template #head(remarks)="">
            <label
              for="remarks"
              :class="attributeData.length > 0 ? 'col-small mandatory' : ''"
              >Remarks</label
            >
          </template>
          <template #cell(remarks)="data">
            <md-field>
              <md-input
                :disabled="!editMode || rfpHdrDetails.bidStatus === 'SUBMIT'"
                v-model="data.item.remarks"
                :title="data.item.remarks"
                maxlength="100"
              ></md-input>
            </md-field>
          </template>
        </b-table>
      </div>
      <div
        v-if="attributeData.length > 0"
        class="md-layout-item md-small-size-100 md-size-45"
      >
        <md-button
          v-if="priceData.length > 1"
          class="md-raised md-primary search-btn"
          @click="copyBoqAttributesData()"
          :disabled="!editMode || rfpHdrDetails.bidStatus === 'SUBMIT'"
          >Copy Attributes to All</md-button
        >
        <md-button
          :disabled="!editMode || rfpHdrDetails.bidStatus === 'SUBMIT'"
          class="md-raised md-primary search-btn"
          @click="postItemAttributeData()"
          >Save</md-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="showLocationDetails"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Location"
      @hidden="showHideLocationDetails(false)"
    >
      <template>
        <div class="md-layout-item">
          <b-table
            striped
            hover
            outlined
            sticky-header
            :items="rpfLocationData"
            :fields="rpfLocationField"
            show-empty
            class="bg-white"
            style="max-height:calc(100vh - 220px)"
            @row-clicked="locationRowSelected"
          >
          </b-table>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="showCopyLocation"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="md"
      title="Copy Location"
      @hidden="showHideCopyLocation(false)"
    >
      <div>
        <md-field>
          <label style="font-size:15px; font-weight: bold;"
            >Selected Version</label
          >
          <div>
            <md-input
              v-model="selectedVersion.text"
              class="md-primary md-small-size-150 md-size-60"
              :title="selectedVersion.text"
              readonly
              :disabled="rfpHdrDetails.version === 1"
              @click="showHideVersion(true)"
            />
            <span
              style="margin-top: -15px;"
              aria-hidden="true"
              class="clearable-icon"
              v-if="selectedVersion.text"
              @click="clearValues('selectedVersion')"
              >×</span
            >
          </div>
        </md-field>
        <label style="font-size:15px;">Selected Location</label>
        <div
          style="min-width:10%; float:right;"
          class="md-layout-item md-small-size-100 md-size-30"
        >
          <md-button
            class="md-raised md-primary search-btn"
            @click="showHideLocations(true)"
            >Add Location</md-button
          >
        </div>
        <div>
          <md-chips
            style="background-color:lightgrey; height: 180px; padding-left:10px; padding-top:4px;"
            class="md-primary pulse-on-error tags auto-expand-tags"
            v-model="selectedLocation"
            md-deletable
            md-check-duplicated
            onkeydown="return false;"
          >
          </md-chips>
        </div>
        <div>
          <md-button
            class="md-raised md-primary search-btn"
            @click="saveCopyBid()"
            >SAVE</md-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="showHideLocationsModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="lg"
      title="Copy Location"
      @hidden="showHideLocations(false)"
    >
      <div>
        <div class="md-layout-item">
          <b-table
            style="max-height:400px;"
            striped
            hover
            outlined
            sticky-header
            :items="copyLocationData"
            :fields="copyLocationField"
            show-empty
            class="bg-white"
          >
            <template #head(selectBox)="data">
              <div>
                <b-form-checkbox
                  v-model="selectAllCheckBox"
                  :value="true"
                  :unchecked-value="false"
                  style="display: inline"
                  @change="selectAllBoxChecked($event)"
                >
                </b-form-checkbox>
                <span>{{ data.label }}</span>
              </div>
            </template>
            <template #cell(selectBox)="data">
              <b-form-checkbox
                v-model="data.item.selectBox"
                :value="true"
                :unchecked-value="false"
                @change="selectBoxChecked($event, data.index, data.item)"
              >
              </b-form-checkbox>
            </template>
          </b-table>
        </div>
      </div>
      <div>
        <md-button
          class="md-raised md-primary search-btn"
          @click="saveCopyBid()"
          >Save</md-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="showHideVersionModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="md"
      title="Copy Version"
      @hidden="showHideVersion(false)"
      @row-clicked="locationRowSelected"
    >
      <div>
        <div class="md-layout-item">
          <b-table
            style="max-height:400px;"
            striped
            hover
            outlined
            sticky-header
            :items="copyVersionData"
            :fields="copyVersionField"
            show-empty
            class="bg-white"
            @row-clicked="versionSelected"
          >
            <!-- <template #head(selectBox)="data">
              <div>
                <b-form-checkbox
                  v-model="selectAllCheckBox"
                  :value="true"
                  :unchecked-value="false"
                  style="display: inline"
                  @change="selectAllBoxChecked($event)"
                >
                </b-form-checkbox>
                <span>{{ data.label }}</span>
              </div>
            </template> -->
            <!-- <template #cell(selectVersion)="data">
              <b-form-checkbox
                v-model="data.item.selectBox"
                :value="true"
                :unchecked-value="false"
                @change="selectBoxChecked($event, data.index, data.item)"
              >
              </b-form-checkbox>
            </template> -->
          </b-table>
        </div>
      </div>
      <div>
        <md-button
          class="md-raised md-primary search-btn"
          @click="showHideVersion(false)"
          >SAVE</md-button
        >
      </div>
    </b-modal>
    <b-modal
      v-model="showReviewModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="wide-modal"
      title="Review BOQ"
      @hidden="showHideReviewModal(false)"
    >
      <template>
        <RFPBoqDetailsReview
          :rfpHdrDetails="rfpHdrDetails"
          :bidHeaderId="bidHeaderId"
          :supplierTerms="supplierPaymentTerms"
        />
      </template>
    </b-modal>
    <!-- <b-modal
      v-model="showDocumentModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Attachment"
      @hidden="showHideDocumentModal(false)"
    >
      <uploadDocument
        :wfHdrId="documentId"
        :openKmAuth="openKmAuth"
        :propMenuId="menuId"
        :PropSubMenuId="subMenuId"
        :approval_status="poHeaderDetails.approval_status"
        formName="rfp"
      />
    </b-modal> -->
    <b-modal
      v-model="showOpenTermsCondition"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Terms & Conditions"
      @hidden="closeTermsCondition(false)"
    >
      <md-button
        class="md-raised md-primary search-btn"
        @click="getOpenKmAuthenticate('tnc')"
        >View Document</md-button
      >
      <b-row>
        <b-col md="12">
          <label for="filter">Terms & Conditions</label>
          <vue-ckeditor
            type="classic"
            :editors="editors"
            :config="editorConfig"
            v-model="summary"
            :title="summary"
          ></vue-ckeditor>
        </b-col>
      </b-row>
      <div v-if="summary">
        <b-row style="margin-top: 50px; margin-left: 10px; display: flex;">
          <b-form-checkbox
            v-model="checkboxFlag"
            :value="true"
            :unchecked-value="false"
          >
          </b-form-checkbox>
          <span>Accept terms and Conditions</span>
        </b-row>
        <b-row>
          <md-button
            class="md-primary"
            :disabled="!checkboxFlag"
            @click="submitBtn()"
            >Accept</md-button
          >
        </b-row>
      </div>
    </b-modal>
    <b-modal
      v-model="openSaveModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="md"
      title="Save Boq"
      @hidden="closeSaveModal(false)"
    >
      <template>
        <div
          style="display: flex; justify-content: center;  flex-wrap: wrap; margin-top: 100px; margin-right: auto; margin-left: auto; gap: 1rem; "
        >
          <p>Some BOQs are excluded. Do you still want to save the Bid?</p>
          <md-button class="md-raised md-accent" @click="saveData()"
            >Yes</md-button
          >
          <md-button class="md-primary" @click="closeModal()">No</md-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      v-model="showPriceModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Price"
      @hidden="showHidePriceModal(false, null)"
    >
      <div>
        <div class="overlayLoader" v-if="loader">
          <md-progress-spinner
            :md-diameter="100"
            class="md-accent spinner-postion"
            :md-stroke="7"
            md-mode="indeterminate"
          ></md-progress-spinner>
        </div>
        <div style="display: flex">
          <div class="md-layout-item md-small-size-100 md-size-20">
            <md-field>
              <label for="font">BOQ Line Code</label>
              <md-input
                v-model="priceModalHeaderData.boq_line_code"
                :title="priceModalHeaderData.boq_line_code"
                disabled
              >
              </md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-35">
            <md-field>
              <label for="font">BOQ Description</label>
              <md-input
                v-model="priceModalHeaderData.description"
                :title="priceModalHeaderData.description"
                disabled
              >
              </md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-10">
            <md-field>
              <label for="font">UOM</label>
              <md-input
                v-model="priceModalHeaderData.uom"
                :title="priceModalHeaderData.uom"
                disabled
              >
              </md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-15">
            <md-field>
              <label for="font">Qty</label>
              <md-input
                v-model="priceModalHeaderData.quantity"
                :title="priceModalHeaderData.quantity"
                disabled
              >
              </md-input>
            </md-field>
          </div>
        </div>
        <div>
          <b-table
            style="max-height:400px;"
            striped
            hover
            bordered
            outlined
            sticky-header
            :items="priceData"
            :fields="priceField"
            show-empty
          >
            <!-- <template #cell(attributes)="data">
              <md-button
                @click="showHideAttributeDetails(true, data.item)"
                class="md-raised md-info search-btn"
                style="min-height: auto;"
                :disabled="rfpHdrDetails.bidStatus === null"
              >
                Attributes
              </md-button>
            </template> -->
            <template #cell(unit_price)="data">
              <md-field>
                <md-input
                  type="number"
                  v-model="data.item.unit_price"
                  :title="data.item.unit_price"
                  :disabled="!editMode || excluded"
                  @change="qtyTwoDecimalValue(data.index)"
                  @input="
                    checkUnitPriceApplicable(data.item.unit_price, data.index)
                  "
                >
                </md-input>
              </md-field>
            </template>
            <template #cell(remarks)="data">
              <md-field>
                <md-input
                  v-model="data.item.remarks"
                  :title="data.item.remarks"
                  :disabled="!editMode || excluded"
                >
                </md-input>
              </md-field>
            </template>
          </b-table>
        </div>
        <div>
          <md-button
            v-if="priceData.length > 1"
            class="md-rose"
            @click="copyUnitPriceToAll()"
            >Copy Unit Price To All</md-button
          >
          <!-- <b-button
            @click="saveBoqData()"
            :disabled="!editMode"
            style="border: none; background-color: green; color: white; padding: 6px 30px; margin-top: 5px; margin-left: 5px; cursor: pointer;"
            >Save</b-button
          >
          <md-button
            v-if="!editMode"
            class="md-raised md-primary search-btn ml-2"
            @click="alterEditMode()"
            >Edit</md-button
          > -->
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="showUploadDocumentModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Upload Document"
      @hidden="showHideUploadDocumentModal(false)"
    >
      <uploadDocument
        v-if="rfpHdrDetails.bidStatus === 'SUBMIT'"
        :wfHdrId="bidHeaderId"
        :openKmAuth="openKmAuth"
        :propMenuId="menuSubmenuBidHeader.menuId"
        :PropSubMenuId="menuSubmenuBidHeader.submenuId"
        :approval_status="poHeaderDetails.approval_status"
        formName="rfpQuotationView"
      />
      <uploadDocument
        v-if="rfpHdrDetails.bidStatus !== 'SUBMIT'"
        :wfHdrId="bidHeaderId"
        :openKmAuth="openKmAuth"
        :propMenuId="menuSubmenuBidHeader.menuId"
        :PropSubMenuId="menuSubmenuBidHeader.submenuId"
        :approval_status="poHeaderDetails.approval_status"
        formName="rfpQuotation"
      />
    </b-modal>
    <b-modal
      v-model="showOpenUploadExcelModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="UPLOAD DOCUMENT"
      @hidden="showHideUploadExcelModal(false)"
    > 
      <template>
        <uploadExcel
          formName="rfpUploadExcel"
          :propMenuId="menuSubmenuExcelUploader.menuId"
          :PropSubMenuId="menuSubmenuExcelUploader.submenuId"
          :wfHdrId="bidHeaderId"
          :rfpHdrId="rfpHdrDetails.rfp_header_id"
          :negotiationVendorId="rfpHdrDetails.negotiation_vendor_id"
          :rfpVendorId="rfpHdrDetails.rfp_vendor_id"
          :negotiationHeaderId="rfpHdrDetails.negotiation_hdr_id"
          :rfpHdrDetails="rfpHdrDetails"
        />
      </template>
    </b-modal>
    <b-modal
      v-model="qnaModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="md"
      title="Q & A"
      @hidden="openQnAModal(false)"
    >
      <template>
        <RFPBOQQNA
          :rfpHdrId="rfpHdrDetails.rfp_header_id"
          :rfpVendorId="rfpHdrDetails.rfp_vendor_id"
          :negotiationHeaderId="rfpHdrDetails.negotiation_hdr_id"
        />
      </template>
    </b-modal>
    <b-modal
      v-model="awardModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-header
      hide-footer
      size="lg"
      modal-class="rfp-award-modal"
      body-class="rfp-award-body"
      @hidden="openCloseAwardModal(false)"
    >
      <template>
        <div class="rfp-award-wrapper">
          <div class="rfp-award-header">
            <div class="rfp-award-header-left">
              <md-icon class="rfp-award-trophy">emoji_events</md-icon>
              <span class="rfp-award-header-sep"></span>
              <span class="rfp-award-header-title">RFP Award Acceptance</span>
            </div>
            <span class="rfp-award-close" @click="awardModal = false"
              >&times;</span
            >
          </div>
          <div class="rfp-award-content">
            <div class="rfp-award-grid">
              <div class="rfp-award-field">
                <label class="rfp-award-label"
                  >Vendor GSTN <span class="rfp-award-req">*</span></label
                >
                <div class="rfp-award-picker">
                  <input
                    type="text"
                    class="rfp-award-control rfp-award-input"
                    v-model="vendorGstn"
                    :title="vendorGstn"
                    placeholder="Select vendor GSTN"
                    readonly
                    :disabled="!saveAwardFlag"
                    @click="saveAwardFlag ? openCloseVendorGstnModal(true) : null"
                  />
                  <span
                    v-if="vendorGstn && saveAwardFlag"
                    class="rfp-award-clear"
                    @click="clearVendorGstn()"
                    >&times;</span
                  >
                </div>
              </div>
              <div class="rfp-award-field">
                <label class="rfp-award-label"
                  >Vendor Billing Site
                  <span class="rfp-award-req">*</span></label
                >
                <div class="rfp-award-picker">
                  <input
                    type="text"
                    class="rfp-award-control rfp-award-input"
                    v-model="vendorBillingSite"
                    :title="vendorBillingSite"
                    placeholder="Select vendor billing site"
                    readonly
                    :disabled="!saveAwardFlag"
                    @click="
                      saveAwardFlag ? openCloseVendorBillingSiteModal(true) : null
                    "
                  />
                  <span
                    v-if="vendorBillingSite && saveAwardFlag"
                    class="rfp-award-clear"
                    @click="clearVendorBillingSite()"
                    >&times;</span
                  >
                </div>
              </div>
              <div class="rfp-award-field rfp-award-full">
                <label class="rfp-award-label"
                  >Vendor Billing Address
                  <span class="rfp-award-req">*</span></label
                >
  
                <b-form-textarea
                  class="rfp-award-address"
                  v-model="vendorBillingAddress"
                  :title="vendorBillingAddress"
                  placeholder="Select vendor GSTN"
                  rows="2"
                  no-resize
                  readonly
                  :disabled="!saveAwardFlag"
                ></b-form-textarea>
              </div>
              <div class="rfp-award-field rfp-award-full">
                <label class="rfp-award-label"
                  >Remarks
                  <span class="rfp-award-optional">(Optional)</span></label
                >
                <div class="rfp-award-textarea-wrapper">
                  <b-form-textarea
                    class="rfp-award-textarea"
                    v-model="awardAcceptanceRemarks"
                    maxlength="500"
                    rows="3"
                    placeholder="Enter remarks (optional)"
                    :disabled="!saveAwardFlag"
                  ></b-form-textarea>
                  <span class="rfp-award-counter"
                    >{{
                      awardAcceptanceRemarks ? awardAcceptanceRemarks.length : 0
                    }}
                    / 500</span
                  >
                </div>
              </div>
    
              <div
                v-if="awardAcceptanceDate"
                class="rfp-award-field rfp-award-date-field"
              >
                <label class="rfp-award-label">Acceptance Date &amp; Time</label>
                <div class="rfp-award-control rfp-award-date">
                  <md-icon class="rfp-award-date-icon">event</md-icon>
                  <span class="rfp-award-date-text">{{
                    awardAcceptanceDateDisplay
                  }}</span>
                </div>
              </div>
              <div
                class="rfp-award-full rfp-award-accept"
                :class="{
                  'rfp-award-accept-on': awardAcceptanceFlag,
                  'rfp-award-accept-off': !saveAwardFlag,
                }"
                @click="toggleAwardAcceptance()"
              >
                <span
                  class="rfp-award-check"
                  :class="{ 'rfp-award-check-on': awardAcceptanceFlag }"
                >
                  <md-icon v-if="awardAcceptanceFlag" class="rfp-award-check-icon"
                    >check</md-icon
                  >
                </span>
                <span class="rfp-award-check-sep"></span>
                <span class="rfp-award-check-text"
                  >I accept the award for this negotiation.</span
                >
              </div>
              <!-- <div class="rfp-award-full rfp-award-attachment">
                <uploadDocument
                  :wfHdrId="rfpAwardVendorId"
                  :openKmAuth="openKmAuth"
                  :propMenuId="menuSubmenuRfpAward.menuId"
                  :PropSubMenuId="menuSubmenuRfpAward.submenuId"
                  :approval_status="poHeaderDetails.approval_status"
                  formName="rfpTnc"
                />
              </div> -->
            </div>
          </div>
          <div class="rfp-award-footer">
            <b-button class="rfp-award-cancel" @click="awardModal = false"
              >Cancel</b-button
            >
            <b-button
              class="rfp-award-submit"
              @click="postRewardDetails()"
              :disabled="!isAwardSubmitEnabled"
              >Submit</b-button
            >
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="vendorGstnModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Vendor GSTN"
      @hidden="openCloseVendorGstnModal(false)"
    >
      <template>
        <div>
          <b-table
            striped
            hover
            outlined
            :items="vendorGstnList"
            :fields="vendorGstnFields"
            show-empty
            class="bg-white font-fix"
            sticky-header
            @row-clicked="rowSelectedVendorGstn"
            style="max-height:calc(100vh - 300px)"
          >
            <template #head(registration_number)="">
              <span>Vendor GST Number</span></template
            >
          </b-table>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-model="vendorBillingSiteModal"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="xl"
      title="Vendor Billing Site"
      @hidden="openCloseVendorBillingSiteModal(false)"
    >
      <template>
        <div>
          <b-table
            striped
            hover
            outlined
            :items="vendorBillingSiteList"
            :fields="vendorBillingSiteFields"
            show-empty
            class="bg-white font-fix"
            sticky-header
            @row-clicked="rowSelectedVendorBillingSite"
            style="max-height:calc(100vh - 300px)"
          >
          </b-table>
        </div>
      </template>
    </b-modal>
    <valueSetModal
      v-if="showValueSetModal"
      @selectedvalueSet="selectedvalueSet"
      @closeValueSetModal="closeValueSetModal"
    ></valueSetModal>
  </div>
</template>

<script>
import commonHelper from "../../../utility/common.helper.utility";
import appStrings from "../../../utility/string.utility";
// import HeaderSummary from "../HeaderSummary.vue";
import RFPBoqDetailsReview from "./RFPBoqDetailsReview.vue";
import uploadDocument from "../../uploadDocument.vue";
import VueCkeditor from "vue-ckeditor5";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import uploadExcel from "../../uploadExcel.vue";
import RFPBOQQNA from "./RFPBOQQNA.vue";

export default {
  name: "RFPDetailsBOQ",
  components: {
    RFPBoqDetailsReview,
    uploadDocument,
    VueCkeditor,
    "vue-ckeditor": VueCkeditor.component,
    uploadExcel,
    RFPBOQQNA,
  },
  watch: {
    currentPage: function() {
      this.getVendorPoLineDetailsById();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getVendorPoLineDetailsById();
    },
  },
  props: ["rowDetails"],
  data() {
    return {
      loader: false,
      pageOptions: commonHelper.getPageOption(),
      perPage: commonHelper.perPageRecord,
      currentPage: 1,
      totalRows: null,
      rfpHdrDetails: {},
      rpfLineBoqField: [
        // {
        //   key: "include_boq",
        // },
        {
          key: "sheet_name",
          label: "Sheet Name",
        },
        {
          key: "s_number",
          label: "Serial No.",
        },
        {
          key: "boq_line_code",
          label: "Activity Code",
        },
        {
          key: "boq_line_subcode",
          label: "Subcode",
        },
        {
          key: "description",
          label: "Description",
        },
        {
          key: "uom",
          label: "UOM",
        },
        {
          key: "quantity",
          label: "Qty.",
        },
        // {
        //   key: "unit_price",
        // },
        // {
        //   key: "remarks",
        // },
        // {
        //   key: "attribute",
        // },
        {
          key: "price",
        },
      ],
      rpfLineBoqData: [],
      poHdrId: null,
      showAttributeDetails: false,
      showLocationDetails: false,
      showCopyLocation: false,
      copyLocationArray: [],
      attributeData: [],
      attributeField: [
        {
          key: "attribute_code",
        },
        {
          key: "attribute_description",
        },
        // {
        //   key: "attribute_specification",
        // },
        // {
        //   key: "rating",
        // },
        {
          key: "remarks",
        },
      ],
      chips: [],
      showValueSetModal: false,
      rpfLocationData: [],
      rpfLocationField: [
        {
          key: "select",
        },
        {
          key: "bid_loc_status",
          label: "Bid Loc Status",
        },
        {
          key: "country",
        },
        {
          key: "region",
        },
        {
          key: "state",
        },
        {
          key: "cost_centre",
        },
        {
          key: "copy_bid",
        },
      ],
      totalLocationDetailsRows: null,
      locationId: null,
      bidHeaderId: 0,
      rfpBoqId: null,
      boqBidId: null,
      showHideLocationsModal: false,
      copyLocationData: [],
      copyLocationField: [
        {
          key: "selectBox",
          label: "Select",
          stickyColumn: true,
          variant: "info",
        },
        {
          key: "bid_loc_status",
        },
        {
          key: "country",
        },
        {
          key: "region",
        },
        {
          key: "state",
        },
        {
          key: "cost_centre",
        },
      ],
      selectedLocation: [],
      selectedLocationId: [],
      selectAllCheckBox: false,
      showReviewModal: false,
      editMode: true,
      excluded: false,
      excludeAllBoqs: false,
      excludeLocationId: null,
      openKmAuth: null,
      showDocumentModal: false,
      venInvoiceId: 0,
      subMenuId: 0,
      poHeaderDetails: {
        approval_status: "DRAFT",
      },
      showOpenTermsCondition: false,
      documentId: 0,
      termId: null,
      summary: null,
      editors: {
        classic: ClassicEditor,
      },
      editorConfig: {
        readOnly: true,
        toolbar: [],
      },
      openSaveModal: false,
      termsFlag: false,
      totalUploadedDocumentRows: null,
      checkboxFlag: false,
      selectedVersion: {
        value: null,
        text: null,
      },
      copyVersionData: [],
      copyVersionField: [
        {
          key: "negotiation_seq",
          label: "Round",
        },
        {
          key: "version",
        },
      ],
      showHideVersionModal: false,
      animate: false,
      reviewAndSubmitFlag: false,
      locationSelected: null,
      showPriceModal: false,
      priceModalHeaderData: {},
      priceData: [],
      priceField: [
        {
          key: "location_name",
        },
        {
          key: "unit_price",
        },
        {
          key: "Remarks",
        },
        // {
        //   key: "attributes",
        // },
      ],
      showUploadDocumentModal: false,
      menuSubmenuRfpHeader: {
        menuId: null,
        submenuId: null,
      },
      menuSubmenuBidHeader: {
        menuId: null,
        submenuId: null,
      },
      showOpenUploadExcelModal: false,
      menuSubmenuExcelUploader: {
        menuId: null,
        submenuId: null,
      },
      menuSubmenuBoqExcel: {
        menuId: null,
        submenuId: null,
      },
      openKmAuthBoqExcel: null,
      recordId: null,
      supplierTerms: null,
      supplierPaymentTerms: null,
      qnaModal: false,
      awardFlag: false,
      awardModal: false,
      awardAcceptanceFlag: false,
      awardAcceptanceRemarks: null,
      awardAcceptanceDate: null,
      vendorGstn: null,
      vendorBillingSite: null,
      vendorBillingAddress: null,
      vendorSiteId: null,
      vendorGstnModal: false,
      vendorGstnData: [],
      vendorGstnList: [],
      vendorGstnFields: [
        {
          key: "registration_number",
          label: "Vendor GST Number",
          class: "align-item-text",
        },
        {
          key: "state_code",
        },
      ],
      vendorBillingSiteModal: false,
      vendorBillingSiteList: [],
      vendorBillingSiteFields: [
        {
          key: "vendor_site_name",
          label: "Vendor Site",
          class: "align-item-text",
        },
        {
          key: "registration_number",
          label: "Vendor GST Number",
          class: "align-item-text",
        },
        {
          key: "address1",
          label: "Vendor Billing Address",
          class: "align-item-text",
        },
      ],
      ouId: null,
      vendorId: null,
      selectedVendorGstn: {
        regNo: null,
        stateCode: null,
      },
      menuSubmenuTermsAndCondition: {
        menuId: null,
        submenuId: null,
      },
      menuSubmenuRfpAward: {
        menuId: null,
        submenuId: null,
      },
      saveAwardFlag: true,
      rfpAwardVendorId: null,
    };
  },
  computed: {
    isAwardSubmitEnabled() {
      return !!(
        this.saveAwardFlag &&
        this.vendorGstn &&
        this.vendorBillingSite &&
        this.vendorBillingAddress &&
        this.awardAcceptanceFlag
      );
    },
    awardAcceptanceDateDisplay() {
      return this.formatAwardDate(this.awardAcceptanceDate);
    },
  },
  created() {
    this.eventBus.$on(
      "totalUploadedDocumentRows",
      (totalUploadedDocumentRows) => {
        this.totalUploadedDocumentRows = totalUploadedDocumentRows;
      }
    );
  },
  mounted() {
    this.vendorId = JSON.parse(sessionStorage.getItem("VendorId"));
    this.setMenuSubmenuId();
    setInterval(() => {
      this.animate = !this.animate;
    }, 2000);
    if (this.rowDetails) {
      this.fillRecordForPoDetails(this.rowDetails);
      this.getOpenKmAuthenticate("attachment");
    }
    this.getLocationDetails();
    this.getRfpAwardDetails();
  },
  methods: {
    fillRecordForPoDetails(item) {
      this.rfpHdrDetails = {
        bidStatus: item.status,
        rfp_number: item.rfp_number,
        description: item.description,
        start_date: item.start_date,
        end_date: item.end_date,
        rfp_header_id: item.rfp_header_id,
        rfp_vendor_id: item.rfp_vendor_id,
        user_id: item.user_id,
        negotiation_hdr_id: item.negotiation_hdr_id,
        negotiation_vendor_id: item.negotiation_vendor_id,
        paymentTerms: item.payment_terms,
        retention: item.retention,
      };
      this.supplierPaymentTerms = item.payment_terms_remarks;
      if (this.supplierPaymentTerms === "Accepted") {
        this.supplierTerms = "Yes";
      } else if (
        this.supplierPaymentTerms === "" ||
        this.supplierPaymentTerms === null
      ) {
        this.supplierTerms = null;
      } else {
        this.supplierTerms = "No";
      }
      this.termId = item.terms_id;
      if (this.termId === null) {
        this.termsFlag = true;
      }
      if (this.rfpHdrDetails.bidStatus === "SUBMIT") {
        this.editMode = false;
      }
      this.getRfpLineData(this.rfpHdrDetails);
    },
    truncateComment(souce, size) {
      return commonHelper.truncate(souce, size);
    },
    showHideAttributeDetails(flag, item) {
      this.rfpBoqId = item.boq_id;
      this.boqBidId = item.boq_bid_id;
      this.getBoqAttributeLineData();

      this.showAttributeDetails = flag;
    },
    showHideLocationDetails(flag) {
      if (flag) {
        this.getLocationDetails();
      }
      this.showLocationDetails = flag;
    },
    showHideCopyLocation(flag) {
      this.showCopyLocation = flag;
    },
    openValueSetModal(vsetCode) {
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null,
        };
        this.eventBus.$emit("valueSetCode", vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (
        this.vsetCode === appStrings.VALUESETTYPE.PARTY_REQ_APPROVAL_STATUS_VSET
      ) {
        const isChipDuplicate = this.chips.some(
          (ele) => ele === item.value_code
        );
        if (!isChipDuplicate) {
          this.chips.push(item.value_code);
        } else {
          alert("Location already selected");
        }
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    // formatCurr(num) {
    //   return commonHelper.formatAmount(Number(num));
    // },
    // getVendorPoLineDetailsById() {
    //   const payload = {
    //     _page: this.currentPage - 1,
    //     _limit: this.perPage,
    //     po_release_id: this.poLineRowDetails.po_release_id,
    //     po_header_id: this.poHdrId,
    //   };
    //   this.loader = true;
    //   this.$store
    //     .dispatch("vendor/getVendorPoLineDetailsById", payload)
    //     .then((resp) => {
    //       this.loader = false;
    //       if (resp.status === 200) {
    //         const result = resp.data.data.data.page;
    //         this.rpfLineBoqData = result.map((elem) => {
    //           elem.need_by_date = commonHelper.formatDate(elem.need_by_date);
    //           elem.promised_date = commonHelper.formatDate(elem.promised_date);
    //           return elem;
    //         });
    //         this.totalRows = resp.data.data.data.total_elements;
    //       }
    //     })
    //     .catch(() => {
    //       this.loader = false;
    //     });
    // },
    getLocationDetails() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        rfp_header_id: this.rfpHdrDetails.rfp_header_id,
        rfp_vendor_id: this.rfpHdrDetails.rfp_vendor_id,
        negotiation_hdr_id: this.rfpHdrDetails.negotiation_hdr_id,
      };
      this.loader = true;
      this.rpfLocationData = [];
      this.$store
        .dispatch("vendor/getRfpLocationDetailsBoq", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.rfpHdrDetails.bidStatus = result[0].status;
            this.rpfLocationData = result;
            this.ouId = result[0].ou_id ? result[0].ou_id : null;
            this.bidHeaderId = result[0].bid_hdr_id ? result[0].bid_hdr_id : 0;
            this.totalLocationDetailsRows = resp.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getExcludeLocationDetails() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        rfp_header_id: this.rfpHdrDetails.rfp_header_id,
        rfp_vendor_id: this.rfpHdrDetails.rfp_vendor_id,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpLocationDetailsBoq", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.rpfExcludeLocationData = result;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    locationRowSelected(item) {
      this.excludeLocationId = item.exc_loc_id;
      if (this.excludeLocationId !== null) {
        this.excluded = true;
      } else {
        this.excluded = false;
      }
      // if (item.state !== null) {
      //   this.rfpHdrDetails.location = item.state;
      // } else if (item.state === null && item.region !== null) {
      //   this.rfpHdrDetails.location = item.region;
      // } else if (item.state === null && item.region === null) {
      //   this.rfpHdrDetails.location = item.country;
      // }
      if (item.cost_centre !== null) {
        this.rfpHdrDetails.location = item.cost_centre;
      } else if (item.cost_centre === null && item.state !== null) {
        this.rfpHdrDetails.location = item.state;
      } else if (
        item.cost_centre === null &&
        item.state === null &&
        item.region !== null
      ) {
        this.rfpHdrDetails.location = item.region;
      } else if (
        item.cost_centre === null &&
        item.state === null &&
        item.region === null
      ) {
        this.rfpHdrDetails.location = item.country;
      }
      this.locationId = item.location_id;
      if (item.bid_hdr_id === null) {
        this.bidHeaderId = 0;
      } else {
        this.bidHeaderId = item.bid_hdr_id;
        this.getRfpBoqData();
      }
      this.showLocationDetails = false;
    },
    excludeLocationRowSelected() {
      let payload = {};
      if (!this.excluded) {
        payload = {
          bid_hdr_id: this.bidHeaderId,
          location_id: this.locationId,
          insert: "1",
        };
      } else {
        payload = {
          bid_hdr_id: this.bidHeaderId,
          location_id: this.locationId,
          insert: "0",
        };
      }

      this.loader = true;
      this.$store
        .dispatch("vendor/postExcludeBoqLocation", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            this.responseMsg = resp.data.message;
            this.makeToast(this.responseMsg, "success");
            this.excluded = !this.excluded;
          } else {
            this.responseMsg = resp.data.message;
            this.makeToast(this.responseMsg, "danger");
          }
        })
        .catch((err) => {
          this.loader = false;
          this.makeToast(err.message, "danger");
        });
      // this.excludeLocation = item.state;
      this.showExcludeLocationDetails = false;
    },
    getRfpLineData(data) {
      const payload = {
        rfp_header_id: data.rfp_header_id,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpLineBoqData", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.totalRows = resp.data.data.total_elements;
            this.rpfLineBoqData = result;
            for (let i of this.rpfLineBoqData) {
              i.boq_bid_id = 0;
            }
            // this.getRfpBoqData();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    postRfpBoqData() {
      let count = 0;
      for (let i of this.rpfLineBoqData) {
        if (!i.include_boq) {
          count++;
        }
      }
      if (count > 0) {
        this.openSaveModal = true;
      } else {
        if (!this.rfpHdrDetails.location) {
          alert("Please select location first!");
        } else {
          this.saveData();
          this.getLocationDetails();
        }
      }
    },

    getRfpBoqData() {
      const payload = {
        bid_hdr_id: this.bidHeaderId,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpBoqData", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            this.rfpHdrDetails.version = resp.data.data.version;
            this.selectedVersion = {
              value: this.bidHeaderId,
              text: this.rfpHdrDetails.version,
            };
            let result = resp.data.data.rfp_vendor_bid_boq_dtls;
            this.rfpHdrDetails.bidStatus = resp.data.data.status;
            if (this.rfpHdrDetails.bidStatus === "SUBMIT") {
              this.editMode = false;
            }
            setTimeout(() => {
              this.editMode = JSON.parse(JSON.stringify(this.editMode));
            }, 0);
            this.totalRows = resp.data.data.total_elements;
            for (let i = 0; i < this.rpfLineBoqData.length; i++) {
              this.rpfLineBoqData[i].unit_price = null;
              this.rpfLineBoqData[i].remarks = null;
              this.rpfLineBoqData[i].boq_bid_id = 0;

              for (let j = 0; j < result.length; j++) {
                if (
                  this.rpfLineBoqData[i].boq_id === result[j].boq_id &&
                  result[j].location_id === this.locationId &&
                  result[j].exc_boq === false
                ) {
                  this.rpfLineBoqData[i].unit_price = "22";
                  this.rpfLineBoqData[i].remarks = result[j].remarks;
                  this.rpfLineBoqData[i].boq_bid_id = result[j].boq_bid_id
                    ? result[j].boq_bid_id
                    : 0;
                  this.rpfLineBoqData[i].include_boq = true;
                } else if (
                  this.rpfLineBoqData[i].boq_id === result[j].boq_id &&
                  result[j].location_id === this.locationId &&
                  result[j].exc_boq === true
                ) {
                  this.rpfLineBoqData[i].unit_price = null;
                  this.rpfLineBoqData[i].remarks = null;
                  this.rpfLineBoqData[i].boq_bid_id = 0;
                  this.rpfLineBoqData[i].include_boq = false;
                }
              }
            }
            setTimeout(() => {
              this.rpfLineBoqData = JSON.parse(
                JSON.stringify(this.rpfLineBoqData)
              );
            }, 0);
          }
          setTimeout(() => {
            this.rpfLineBoqData = JSON.parse(
              JSON.stringify(this.rpfLineBoqData)
            );
          }, 0);
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getBoqAttributeLineData() {
      const payload = {
        boq_id: this.priceModalHeaderData.boq_id,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpBoqAttributeLineData", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.attributeData = result;
            this.getBoqAttributeData();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    postItemAttributeData() {
      let details = [];
      let count = 0;
      for (let i of this.attributeData) {
        if (i.remarks === null) {
          count++;
        }
        details.push({
          boq_bid_attribute_id: i.boq_bid_attribute_id
            ? i.boq_bid_attribute_id
            : 0,
          boq_attribute_id: i.boq_attribute_id,
          rating: i.rating,
          remarks: i.remarks,
        });
      }
      if (count > 0) {
        alert("Remarks mandatory!");
      } else {
        const payload = {
          boq_bid_id: this.boqBidId,
          boq_id: this.priceModalHeaderData.boq_id,
          rfp_boq_attribute_bid_dtls: details,
        };
        this.loader = true;
        this.$store
          .dispatch("vendor/postRfpBoqAttributeData", payload)
          .then((resp) => {
            this.loader = false;
            if (resp.status === 200) {
              this.responseMsg = resp.data.message;
              this.makeToast(this.responseMsg, "success");
              this.getBoqAttributeLineData();
            } else {
              this.responseMsg = resp.data.message;
              this.makeToast(this.responseMsg, "danger");
            }
          })
          .catch((err) => {
            this.loader = false;
            this.makeToast(err.message, "danger");
          });
        this.showAttributeDetails = false;
      }
    },
    getBoqAttributeData() {
      for (let i of this.attributeData) {
        i.remarks = null;
      }
      const payload = {
        boq_bid_id: this.boqBidId,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpBoqAttributeData", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            for (let i = 0; i < this.attributeData.length; i++) {
              this.attributeData[i].rating = result[i].rating;
              this.attributeData[i].remarks = result[i].remarks;
              this.attributeData[i].boq_bid_attribute_id =
                result[i].boq_bid_attribute_id;
            }
          }
          setTimeout(() => {
            this.attributeData = JSON.parse(JSON.stringify(this.attributeData));
          }, 0);
        })
        .catch(() => {
          this.loader = false;
        });
    },
    hideAttributepDetails() {
      this.showAttributeDetails = false;
    },
    showHideLocations(flag) {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        rfp_header_id: this.rfpHdrDetails.rfp_header_id,
        rfp_vendor_id: this.rfpHdrDetails.rfp_vendor_id,
        negotiation_hdr_id: this.rfpHdrDetails.negotiation_hdr_id,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpLocationDetailsBoq", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.copyLocationData = result;
            this.copyLocationData = this.copyLocationData.filter(
              (el) =>
                el.location_id !== this.locationId && el.exc_loc_id === null
            );
          }
        })
        .catch(() => {
          this.loader = false;
        });
      this.showHideLocationsModal = flag;
      this.selectAllCheckBox = false;
    },
    selectBoxChecked(flag, index, item) {
      this.copyLocationData[index].selectBox = flag;
      if (flag === true) {
        if (item.cost_centre !== null) {
          this.selectedLocation.push(item.cost_centre);
        } else if (item.cost_centre === null && item.state !== null) {
          this.selectedLocation.push(item.state);
        } else if (
          item.cost_centre === null &&
          item.state === null &&
          item.region !== null
        ) {
          this.selectedLocation.push(item.region);
        } else if (
          item.cost_centre === null &&
          item.state === null &&
          item.region === null
        ) {
          this.selectedLocation.push(item.country);
        }
        this.selectedLocationId.push(item.location_id);
        if (this.selectedLocation.length === this.copyLocationData.length) {
          this.selectAllCheckBox = true;
        }
      } else {
        this.selectAllCheckBox = false;
        if (item.cost_centre !== null) {
          this.selectedLocation = this.selectedLocation.filter(
            (el) => el !== item.cost_centre
          );
        } else if (item.cost_centre === null && item.state !== null) {
          this.selectedLocation = this.selectedLocation.filter(
            (el) => el !== item.state
          );
        } else if (
          item.cost_centre === null &&
          item.state === null &&
          item.region !== null
        ) {
          this.selectedLocation = this.selectedLocation.filter(
            (el) => el !== item.region
          );
        } else if (
          item.cost_centre === null &&
          item.state === null &&
          item.region === null
        ) {
          this.selectedLocation = this.selectedLocation.filter(
            (el) => el !== item.country
          );
        }
        this.selectedLocationId = this.selectedLocationId.filter(
          (el) => el !== item.location_id
        );
      }
    },
    selectAllExcludedBoq(flag) {
      if (flag) {
        for (let i of this.rpfLineBoqData) {
          i.exclude_boq = true;
        }
      } else {
        for (let i of this.rpfLineBoqData) {
          i.exclude_boq = false;
        }
      }
      setTimeout(() => {
        this.rpfLineBoqData = JSON.parse(JSON.stringify(this.rpfLineBoqData));
      }, 0);
    },
    selectAllBoxChecked(flag) {
      this.selectedLocation = [];
      this.selectedLocationId = [];
      if (flag) {
        for (let i of this.copyLocationData) {
          i.selectBox = true;
          if (i.cost_centre !== null) {
            this.selectedLocation.push(i.cost_centre);
          } else if (i.cost_centre === null && i.state !== null) {
            this.selectedLocation.push(i.state);
          } else if (
            i.cost_centre === null &&
            i.state === null &&
            i.region !== null
          ) {
            this.selectedLocation.push(i.region);
          } else if (
            i.cost_centre === null &&
            i.state === null &&
            i.region === null
          ) {
            this.selectedLocation.push(i.country);
          }
          this.selectedLocationId.push(i.location_id);
        }
      } else {
        for (let i of this.copyLocationData) {
          i.selectBox = false;
        }
        this.selectedLocation = [];
        this.selectedLocationId = [];
      }
      setTimeout(() => {
        this.copyLocationData = JSON.parse(
          JSON.stringify(this.copyLocationData)
        );
      }, 0);
    },
    makeToast(content, variant) {
      this.$bvToast.toast(content, {
        title: "Alert",
        variant: variant,
        solid: true,
        toaster: "b-toaster-top-center",
        appendToast: true,
        toastClass: "custom-toast",
      });
    },
    saveCopyBid() {
      let copybiddetails = [];
      for (let i of this.selectedLocationId) {
        copybiddetails.push({
          to_location_id: i,
        });
      }
      const payload = {
        rfp_header_id: this.rfpHdrDetails.rfp_header_id,
        from_bid_hdr_id: this.selectedVersion.value,
        bid_hdr_id: this.bidHeaderId,
        from_location_id: this.locationId,
        rfp_boq_copy_bid_dtls: copybiddetails,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/postCopyBoqBid", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            this.editMode = false;
            this.responseMsg = "Bid Copied Successfully for other locations";
            this.makeToast(this.responseMsg, "success");
            this.showCopyLocation = false;
            this.showReviewModal = false;
          } else {
            this.responseMsg = resp.data.message;
            this.makeToast(this.responseMsg, "danger");
          }
        })
        .catch((err) => {
          this.loader = false;
          this.makeToast(err.message, "danger");
        });
    },
    showHideReviewModal(flag) {
      this.reviewAndSubmitFlag = flag;
      this.showReviewModal = flag;
    },
    alterEditBidMode() {
      this.editMode = !this.editMode;
    },
    getOpenKmAuthenticate(type) {
      if (type === "attachment") {
        (this.documentId = this.rfpHdrDetails.rfp_header_id),
          (this.subMenuId = 0);
      } else {
        const menuitem = JSON.parse(sessionStorage.getItem("RFPTNC"));
        this.subMenuId = menuitem.sub_menu_id;
        this.documentId = this.termId;
      }
      this.loader = true;
      this.$store
        .dispatch("uploadDocument/getOpenKmAuthenticate")
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            this.showHideDocumentModal(true);
          } else {
            alert(appStrings.DEPENDENTVSETMSG.DEFAULTMSG);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideDocumentModal(flag) {
      this.showDocumentModal = flag;
    },
    openTermsCondition() {
      this.checkboxFlag = false;
      if (this.termId === null) {
        this.termsFlag = true;
      } else {
        const payload = {
          term_id: this.termId,
        };

        this.loader = true;
        this.$store
          .dispatch("vendor/getTermId", payload)
          .then((response) => {
            this.loader = false;
            if (response.status === 200) {
              setTimeout(() => {
                this.summary = response.data.data.rfp_t_and_c;
              }, 500);
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
      this.showOpenTermsCondition = true;
    },
    closeTermsCondition(flag) {
      this.showOpenTermsCondition = flag;
    },
    qtyTwoDecimalValue(index) {
      let unitPrice = this.priceData[index].unit_price.toString().split(".");

      if (unitPrice.length > 1 && unitPrice[1].length > 2) {
        this.priceData[index].unit_price = parseFloat(
          this.priceData[index].unit_price
        ).toFixed(2);
        alert("Only Two Decimal Value Allowed.");
        // this.priceData[index].unit_price = "";
      }
    },
    checkUnitPriceApplicable(unitPrice, index) {
      if (unitPrice && unitPrice > 0) {
        this.priceData[index].include_boq = true;
      } else {
        this.priceData[index].include_boq = false;
      }
    },
    closeSaveModal(flag) {
      this.openSaveModal = flag;
    },
    closeModal() {
      this.openSaveModal = false;
    },
    saveData() {
      let vendorbiddetails = [];
      for (let i of this.rpfLineBoqData) {
        vendorbiddetails.push({
          boq_bid_id: i.boq_bid_id,
          boq_id: i.boq_id,
          unit_price: i.unit_price,
          remarks: i.remarks,
          location_id: this.locationId,
          exc_boq: !i.include_boq,
        });
      }
      const payload = {
        bid_hdr_id: this.bidHeaderId,
        negotiation_hdr_id: this.rowDetails.negotiation_hdr_id,
        negotiation_vendor_id: this.rowDetails.negotiation_vendor_id,
        rfp_header_id: this.rowDetails.rfp_header_id,
        version: 0,
        status: "DRAFT",
        rfp_vendor_bid_boq_dtls: vendorbiddetails,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/postRfpBoqData", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            this.rfpHdrDetails.bidStatus = resp.data.data.status;
            if (this.rfpHdrDetails.bidStatus === "SUBMIT") {
              this.editMode = false;
            }
            const result = resp.data.data;
            this.bidHeaderId = result.bid_hdr_id;
            this.responseMsg = resp.data.message;
            this.makeToast(this.responseMsg, "success");
            // this.eventBus.$emit("bidHeaderId", this.bidHeaderId);
            this.getRfpBoqData();
            if (this.reviewAndSubmitFlag) {
              this.reviewAndSubmitFlag = false;
              this.showReviewModal = true;
            }
          } else {
            this.responseMsg = response.response.data.message;
            this.makeToast(this.responseMsg, "danger");
          }
        })
        .catch((err) => {
          this.loader = false;
          this.makeToast(err.message, "danger");
        });
      this.openSaveModal = false;
    },
    submitBtn() {
      this.totalUploadedDocumentRows = null;
      this.termsFlag = true;
      this.showOpenTermsCondition = false;
    },
    showHideVersion(flag) {
      const payload = {
        rfp_header_id: this.rfpHdrDetails.rfp_header_id,
        rfp_vendor_id: this.rfpHdrDetails.rfp_vendor_id,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpVersion", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data;
            this.copyVersionData = result;
            (this.negotiation_seq = result.negotiation_seq),
              (this.version = result.version),
              (this.bid_hdr_id = result.bid_hdr_id);
          }
        })
        .catch(() => {
          this.loader = false;
        });
      this.showHideVersionModal = flag;
    },
    versionSelected(item) {
      this.selectedVersion = {
        value: item.bid_hdr_id,
        text: item.version,
      };
      this.showHideVersionModal = false;
    },
    clearValues(value) {
      if (value === "selectedVersion") {
        if (this.selectedVersion.value === this.bidHeaderId) {
          alert("You cannot clear the current version");
        } else {
          this.selectedVersion = {
            value: null,
            text: null,
          };
        }
      }
    },
    openReviewModal() {
      if (
        this.supplierPaymentTerms === null ||
        this.supplierPaymentTerms === ""
      ) {
        alert("Please enter Supplier Terms first");
      } else {
        this.reviewAndSubmitFlag = true;
        if (this.locationSelected === null) {
          this.showReviewModal = true;
        } else {
          this.postRfpBoqData();
        }
      }
    },
    showHidePriceModal(flag, item) {
      if (item) {
        this.priceModalHeaderData = item;
        this.getLocationData();
      }
      this.showPriceModal = flag;
    },
    getLocationData() {
      const payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        rfp_header_id: this.rfpHdrDetails.rfp_header_id,
        rfp_vendor_id: this.rfpHdrDetails.rfp_vendor_id,
        negotiation_hdr_id: this.rfpHdrDetails.negotiation_hdr_id,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpLocationDetails", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.page;
            this.priceData = result;
            this.bidHeaderId = result[0].bid_hdr_id ? result[0].bid_hdr_id : 0;
            this.totalLocationDetailsRows = resp.data.data.total_elements;
            this.getRfpData();
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    saveBoqData() {
      let count = 0;
      for (let i of this.priceData) {
        if (!i.unit_price || +i.unit_price === 0) {
          count = count + 1;
        }
      }
      if (count > 0) {
        alert("Unit Price Mandatory");
      } else {
        let vendorbiddetails = [];
        for (let i of this.priceData) {
          vendorbiddetails.push({
            boq_bid_id:
              this.rfpHdrDetails.bidStatus === "SUBMIT" ||
              this.rfpHdrDetails.bidStatus === "" ||
              this.rfpHdrDetails.bidStatus === null
                ? 0
                : i.boq_bid_id,
            boq_id: this.priceModalHeaderData.boq_id,
            unit_price: i.unit_price,
            remarks: i.remarks,
            location_id: i.location_id,
            exc_boq: !i.include_boq,
          });
        }
        const payload = {
          bid_hdr_id:
            this.rfpHdrDetails.bidStatus === "SUBMIT" ? 0 : this.bidHeaderId,
          negotiation_hdr_id: this.rowDetails.negotiation_hdr_id,
          negotiation_vendor_id: this.rowDetails.negotiation_vendor_id,
          rfp_header_id: this.rowDetails.rfp_header_id,
          version: 0,
          status: "DRAFT",
          rfp_vendor_bid_boq_dtls: vendorbiddetails,
        };
        this.loader = true;
        this.$store
          .dispatch("vendor/postRfpBoqData", payload)
          .then((resp) => {
            this.loader = false;
            if (resp.status === 200) {
              this.rfpHdrDetails.bidStatus = resp.data.data.status;
              if (this.rfpHdrDetails.bidStatus === "SUBMIT") {
                this.editMode = false;
              }
              const result = resp.data.data;
              this.bidHeaderId = result.bid_hdr_id;
              this.responseMsg = resp.data.message;
              this.makeToast(this.responseMsg, "success");
              // this.eventBus.$emit("bidHeaderId", this.bidHeaderId);
              // this.getRfpBoqData();
              this.getLocationData();
              if (this.reviewAndSubmitFlag) {
                this.reviewAndSubmitFlag = false;
                this.showReviewModal = true;
              }
            } else {
              this.responseMsg = response.response.data.message;
              this.makeToast(this.responseMsg, "danger");
            }
          })
          .catch((err) => {
            this.loader = false;
            this.makeToast(err.message, "danger");
          });
        this.openSaveModal = false;
      }
    },
    getRfpData() {
      const payload = {
        bid_hdr_id: this.bidHeaderId,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpBoqData", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            this.rfpHdrDetails.version = resp.data.data.version;
            this.selectedVersion = {
              value: this.bidHeaderId,
              text: this.rfpHdrDetails.version,
            };
            let result = resp.data.data.rfp_vendor_bid_boq_dtls;
            this.rfpHdrDetails.bidStatus = resp.data.data.status;
            if (this.rfpHdrDetails.bidStatus === "SUBMIT") {
              this.editMode = false;
            }
            setTimeout(() => {
              this.editMode = JSON.parse(JSON.stringify(this.editMode));
            }, 0);
            this.totalRows = resp.data.data.total_elements;
            for (let i = 0; i < this.priceData.length; i++) {
              this.priceData[i].unit_price = null;
              this.priceData[i].remarks = null;
              this.priceData[i].boq_bid_id = 0;

              for (let j = 0; j < result.length; j++) {
                if (
                  this.priceModalHeaderData.boq_id === result[j].boq_id &&
                  result[j].location_id === this.priceData[i].location_id &&
                  result[j].exc_boq === false
                ) {
                  this.priceData[i].unit_price = result[j].unit_price;
                  this.priceData[i].remarks = result[j].remarks;
                  this.priceData[i].boq_bid_id = result[j].boq_bid_id
                    ? result[j].boq_bid_id
                    : 0;
                  this.priceData[i].include_boq = true;
                } else if (
                  this.priceModalHeaderData.boq_id === result[j].boq_id &&
                  result[j].location_id === this.priceData[i].location_id &&
                  result[j].exc_boq === true
                ) {
                  this.priceData[i].unit_price = null;
                  this.priceData[i].remarks = null;
                  this.priceData[i].boq_bid_id = 0;
                  this.priceData[i].include_boq = false;
                }
              }
            }
            setTimeout(() => {
              this.priceData = JSON.parse(JSON.stringify(this.priceData));
            }, 500);
          }
          setTimeout(() => {
            this.rpfLineBoqData = JSON.parse(
              JSON.stringify(this.rpfLineBoqData)
            );
          }, 0);
        })
        .catch(() => {
          this.loader = false;
        });
    },
    copyUnitPriceToAll() {
      let count = 0;
      let unitPrice = 0;
      let remarks = null;
      let unitPriceCount = 0;
      for (let i of this.priceData) {
        if (i.unit_price > 0) {
          unitPriceCount = unitPriceCount + 1;
        }
      }
      if (unitPriceCount === 0) {
        alert("Please enter Unit Price first");
      } else {
        for (let i of this.priceData) {
          if (i.unit_price && i.unit_price !== null && i.unit_price !== "") {
            count++;
            unitPrice = i.unit_price;
            remarks = i.remarks;
          }
        }
        if (count === 1) {
          for (let i of this.priceData) {
            i.unit_price = unitPrice;
            i.remarks = remarks;
          }
          setTimeout(() => {
            this.priceData = JSON.parse(JSON.stringify(this.priceData));
          }, 0);
        } else {
          alert(
            "You have entered multiple prices for this item. Copying prices is not allowed."
          );
        }
      }
    },
    alterEditMode() {
      this.editMode = true;
    },
    copyBoqAttributesData() {
      let bidCopyAttributeDetails = [];
      for (let i of this.priceData) {
        bidCopyAttributeDetails.push({
          to_boq_bid_id: i.boq_bid_id,
        });
      }
      const payload = {
        boq_id: this.priceModalHeaderData.boq_id,
        from_boq_bid_id: this.boqBidId,
        rfp_boq_bid_copy_atr_dtls: bidCopyAttributeDetails,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/copyBoqAttributeData", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            this.responseMsg = resp.data.data;
            this.makeToast(this.responseMsg, "success");
          } else {
            this.responseMsg = resp.data.data;
            this.makeToast(this.responseMsg, "danger");
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    getOpenKmAuthenticateUploadDocument() {
      this.loader = true;
      this.$store
        .dispatch("uploadDocument/getOpenKmAuthenticate")
        .then((response) => {
          this.loader = false;
          if (response.status === 200) {
            this.openKmAuth = response.data.data.token;
            this.showHideUploadDocumentModal(true);
          } else {
            alert(appStrings.DEPENDENTVSETMSG.DEFAULTMSG);
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    showHideUploadDocumentModal(flag) {
      this.showUploadDocumentModal = flag;
    },
    setMenuSubmenuId() {
      const menuRfpHeader = JSON.parse(sessionStorage.getItem("rfpHeader"));
      this.menuSubmenuRfpHeader = {
        menuId: menuRfpHeader.menu_id,
        submenuId: menuRfpHeader.sub_menu_id,
      };
      const menuBidHeader = JSON.parse(sessionStorage.getItem("rfpBidHdr"));
      this.menuSubmenuBidHeader = {
        menuId: menuBidHeader.menu_id,
        submenuId: menuBidHeader.sub_menu_id,
      };
      const menuExcelUploader = JSON.parse(
        sessionStorage.getItem("rfpExcelUploader")
      );
      this.menuSubmenuExcelUploader = {
        menuId: menuExcelUploader.menu_id,
        submenuId: menuExcelUploader.sub_menu_id,
      };
      const menuBoqExcel = JSON.parse(sessionStorage.getItem("rfpBoqExcel"));
      this.menuSubmenuBoqExcel = {
        menuId: menuBoqExcel.menu_id,
        submenuId: menuBoqExcel.sub_menu_id,
      };
      const menuItemTermsAndCondition = JSON.parse(
        sessionStorage.getItem("rfpTermsAndConditions")
      );
      this.menuSubmenuTermsAndCondition = {
        menuId: menuItemTermsAndCondition.menu_id,
        submenuId: menuItemTermsAndCondition.sub_menu_id,
      };
      const menuRfpAward = JSON.parse(sessionStorage.getItem("rfpAward"));
      this.menuSubmenuRfpAward = {
        menuId: menuRfpAward.menu_id,
        submenuId: menuRfpAward.sub_menu_id,
      };
    },
    downloadExcelData() {
      let customDownloadData = [];
      for (let i of this.rpfLineBoqData) {
        customDownloadData.push({
          row_number: i.r_number,
          serial_number: i.s_number,
          activity_code: i.boq_line_code,
          subcode: i.boq_line_subcode,
          description: i.description,
          uom: i.uom,
          total_qty: i.quantity,
          unit_price: null,
        });
      }
      commonHelper.downloadExcel(customDownloadData, "boq-data");
    },
    uploadExcel() {
      this.showOpenUploadExcelModal = true;
    },
    showHideUploadExcelModal(flag) {
      this.getLocationDetails();
      this.showOpenUploadExcelModal = flag;
    },
    checkPaymentTermsAcceptance(type) {
      if (type === "Yes") {
        this.supplierPaymentTerms = "Accepted";
      } else {
        this.supplierPaymentTerms = null;
      }
    },
    openQnAModal(flag) {
      this.qnaModal = flag;
    },
    getRfpAwardDetails() {
      const payload = {
        rfpHdrId: this.rfpHdrDetails.rfp_header_id,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpAwardDetails", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            if (
              resp.data.data &&
              resp.data.data.length &&
              resp.data.data[0].rfp_vendor_id ===
                this.rfpHdrDetails.rfp_vendor_id
            ) {
              this.vendorGstn = resp.data.data[0].rfp_award_vendor_gstn
                ? resp.data.data[0].rfp_award_vendor_gstn
                : null;
              this.selectedVendorGstn.regNo = this.vendorGstn;
              this.vendorBillingSite = resp.data.data[0].vendor_site_code
                ? resp.data.data[0].vendor_site_code
                : null;
              this.vendorBillingAddress = resp.data.data[0].address1
                ? resp.data.data[0].address1
                : null;
              this.vendorSiteId = resp.data.data[0].vendor_site_id
                ? resp.data.data[0].vendor_site_id
                : null;
              this.awardAcceptanceRemarks = resp.data.data[0].acceptance_remarks
                ? resp.data.data[0].acceptance_remarks
                : null;
              this.awardAcceptanceDate = resp.data.data[0].acceptance_date
                ? resp.data.data[0].acceptance_date
                : this.awardAcceptanceDate;
              this.awardAcceptanceFlag =
                resp.data.data[0].acceptance_flag === 1 ? true : false;
              this.rfpAwardVendorId = resp.data.data[0].rfp_award_vendor_id
                ? resp.data.data[0].rfp_award_vendor_id
                : null;
              if (resp.data.data[0].acceptance_flag === 1) {
                this.saveAwardFlag = false;
              }
              if (resp.data.data[0].approval_status === "APPROVED") {
                this.awardFlag = true;
              }
            }
          } else {
            this.responseMsg = resp.data.data;
            this.makeToast(this.responseMsg, "danger");
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    openCloseAwardModal(flag) {
      this.getRfpAwardDetails();
      if (flag) {
        this.getVendorGstnVendorInvoice();
      }
      this.awardModal = flag;
    },
    formatAwardDate(dateValue) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let date = new Date();
      if (dateValue) {
        const parts = String(dateValue).split(" ");
        const dateParts = parts[0].split("-");
        const timeParts = parts[1] ? parts[1].split(":") : ["0", "0", "0"];
        if (dateParts.length === 3) {
          date = new Date(
            parseInt(dateParts[2]),
            parseInt(dateParts[1]) - 1,
            parseInt(dateParts[0]),
            parseInt(timeParts[0]),
            parseInt(timeParts[1])
          );
        } else {
          date = new Date(dateValue);
        }
      }
      if (isNaN(date.getTime())) {
        return dateValue;
      }
      let hours = date.getHours();
      const meridiem = hours >= 12 ? "PM" : "AM";
      hours = hours % 12 ? hours % 12 : 12;
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${String(date.getDate()).padStart(2, "0")} ${
        months[date.getMonth()]
      } ${date.getFullYear()}, ${String(hours).padStart(
        2,
        "0"
      )}:${minutes} ${meridiem}`;
    },
    clearVendorGstn() {
      this.vendorGstn = null;
      this.selectedVendorGstn = {
        regNo: null,
        stateCode: null,
      };
      this.vendorBillingSite = null;
      this.vendorBillingAddress = null;
      this.vendorSiteId = null;
      this.vendorBillingSiteList = [];
    },
    getLocalDateTime() {
      let now = new Date();
      let year = now.getFullYear();
      let month = String(now.getMonth() + 1).padStart(2, "0");
      let day = String(now.getDate()).padStart(2, "0");
      let hours = String(now.getHours()).padStart(2, "0");
      let minutes = String(now.getMinutes()).padStart(2, "0");
      let seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    openCloseVendorGstnModal(flag) {
      this.getVendorGstnVendorInvoice();
      this.vendorGstnModal = flag;
    },
    rowSelectedVendorGstn(item) {
      this.selectedVendorGstn = {
        regNo: item.registration_number,
        stateCode: item.state_code,
      };
      this.vendorGstn = item.registration_number;
      this.vendorBillingSite = item.vendor_site_code
        ? item.vendor_site_code
        : null;
      this.vendorBillingAddress = item.address1 ? item.address1 : null;
      this.vendorSiteId = item.vendor_site_id ? item.vendor_site_id : null;
      this.vendorBillingSiteList = [];
      this.vendorGstnModal = false;
    },
    openCloseVendorBillingSiteModal(flag) {
      if (flag) {
        if (!this.vendorGstn) {
          this.makeToast("Please select Vendor GSTN first", "warning");
          return;
        }
        this.getRfpManualVendorSiteName();
      }
      this.vendorBillingSiteModal = flag;
    },
    getRfpManualVendorSiteName() {
      const payload = {
        _page: 0,
        _limit: 1000,
        vendor_site_name: null,
        vendor_id: this.vendorId,
        org_id: this.ouId,
        invoice_date: this.formatSiteInvoiceDate(this.rfpHdrDetails.start_date),
        registration_number: this.vendorGstn,
      };
      this.loader = true;
      this.vendorBillingSiteList = [];
      this.$store
        .dispatch("vendor/getRfpManualVendorSiteName", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            this.vendorBillingSiteList = resp.data.data.page;
          } else {
            this.responseMsg = resp.data.message;
            this.makeToast(this.responseMsg, "danger");
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    formatSiteInvoiceDate(dateValue) {
      if (!dateValue) {
        return null;
      }
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const parts = String(dateValue).trim().split(" ")[0].split("-");
      if (parts.length !== 3) {
        return dateValue;
      }
      // Already in DD-MON-YYYY / DD-Mon-YYYY format coming from the RFP header
      if (isNaN(parts[1])) {
        return commonHelper.formatDate(
          `${parts[0]}-${parts[1].toUpperCase()}-${parts[2]}`
        );
      }
      // YYYY-MM-DD from the API
      if (parts[0].length === 4) {
        return `${parts[2]}-${months[parseInt(parts[1]) - 1]}-${parts[0]}`;
      }
      // DD-MM-YYYY from the API
      return `${parts[0]}-${months[parseInt(parts[1]) - 1]}-${parts[2]}`;
    },
    rowSelectedVendorBillingSite(item) {
      this.vendorBillingSite = item.vendor_site_name
        ? item.vendor_site_name
        : null;
      this.vendorBillingAddress = item.address1 ? item.address1 : null;
      this.vendorSiteId = item.vendor_site_id ? item.vendor_site_id : null;
      this.vendorBillingSiteModal = false;
    },
    clearVendorBillingSite() {
      this.vendorBillingSite = null;
      this.vendorBillingAddress = null;
      this.vendorSiteId = null;
    },
    getVendorGstnVendorInvoice() {
      const payload = {
        _page: 0,
        _limit: 1000,
        le_id: 24276,
        vendor_id: this.vendorId,
        vendor_gstn: null,
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/getRfpVendorGstn", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            const result = resp.data.data.data.page;
            this.vendorGstnData = result;
            this.vendorGstnList = result.filter(
              (item, index) =>
                result.findIndex(
                  (gstn) =>
                    gstn.registration_number === item.registration_number &&
                    gstn.vendor_site_code === item.vendor_site_code &&
                    gstn.address1 === item.address1
                ) === index
            );
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    postRewardDetails() {
      const payload = {
        rfp_header_id: this.rfpHdrDetails.rfp_header_id,
        rfp_vendor_award_remarks_dtls: [
          {
            rfp_vendor_id: this.rfpHdrDetails.rfp_vendor_id,
            rfp_award_vendor_gstn: this.vendorGstn,
            vendor_site_code: this.vendorBillingSite,
            vendor_site_id: this.vendorSiteId,
            address1: this.vendorBillingAddress,
            acceptance_flag: this.awardAcceptanceFlag ? 1 : 0,
            // acceptance_date: this.awardAcceptanceDate,
            acceptance_remarks: this.awardAcceptanceRemarks,
          },
        ],
      };
      this.loader = true;
      this.$store
        .dispatch("vendor/postRfpAwardDetails", payload)
        .then((resp) => {
          this.loader = false;
          if (resp.status === 200) {
            this.makeToast("Award Accepted Successfully", "success");
            this.awardModal = false;
          } else {
            alert("Something went wrong");
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    toggleAwardAcceptance() {
      if (this.saveAwardFlag) {
        this.awardAcceptanceFlag = !this.awardAcceptanceFlag;
      }
    },
  },

  beforeDestroy() {
    // this.eventBus.$off("bidHeaderId");
  },
};
</script>

<style>
@keyframes moveUpDown {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.icon-animate {
  margin-top: -20px;
  font-size: 20px;
  color: red;
  animation: moveUpDown 1s ease-in-out infinite;
}

.icon {
  margin-top: -20px;
  font-size: 20px;
  color: red;
}
.icon {
  cursor: pointer;
}
.ck-editor__editable[role="textbox"] {
  pointer-events: none;
}
.custom-toast {
  padding: 20px;
}
</style>
<style scoped>
.rfp-award-wrapper {
  margin: -1rem;
  color: #12356b;
}
/* Header */
.rfp-award-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 28px;
  background: linear-gradient(90deg, #b3175c 0%, #cf1a67 100%);
  color: #ffffff;
}
.rfp-award-header-left {
  display: flex;
  align-items: center;
}
.rfp-award-trophy {
  color: #ffffff !important;
  font-size: 32px !important;
  width: 32px;
  min-width: 32px;
  height: 32px;
  margin: 0;
}
.rfp-award-header-sep {
  width: 1px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.55);
  margin: 0 18px;
}
.rfp-award-header-title {
  font-size: 22px;
  font-weight: 600;
  line-height: 1;
}
.rfp-award-close {
  font-size: 30px;
  line-height: 1;
  cursor: pointer;
  opacity: 0.9;
}
.rfp-award-close:hover {
  opacity: 1;
}
.rfp-award-content {
  padding: 24px 28px 20px 28px;
}
.rfp-award-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  row-gap: 18px;
  align-items: start;
}
.rfp-award-full {
  grid-column: 1 / 3;
  width: 100%;
}
.rfp-award-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.rfp-award-label {
  display: block;
  margin-bottom: 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.2;
  color: #12356b;
}
.rfp-award-req {
  color: #e3002b;
}
.rfp-award-optional {
  font-weight: 400;
  color: #7b8aa5;
}
.rfp-award-control {
  height: 46px;
  border: 1px solid #dbe1ea;
  border-radius: 8px;
  font-size: 15px;
  color: #12356b;
}
.rfp-award-picker {
  position: relative;
}
.rfp-award-input {
  width: 100%;
  padding: 10px 40px 10px 14px;
  background-color: #f7f9fc;
  cursor: pointer;
}
.rfp-award-input::placeholder {
  color: #9aa7bd;
}
.rfp-award-input:disabled {
  cursor: not-allowed;
  background-color: #eef1f6;
}
.rfp-award-clear {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 22px;
  line-height: 1;
  color: #7b8aa5;
  cursor: pointer;
}
.rfp-award-select {
  width: 100%;
  padding: 10px 40px 10px 14px;
  background-color: #ffffff;
}
.rfp-award-select:disabled {
  background-color: #eef1f6;
}

.rfp-award-date-field {
  grid-column: 1 / 2;
}
.rfp-award-date {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 14px;
  background-color: #f1f4f9;
  text-align: left;
}
.rfp-award-date-text {
  margin-right: auto;
}
.rfp-award-date-icon {
  font-size: 22px !important;
  color: #12356b !important;
  width: 22px;
  min-width: 22px;
  height: 22px;
  margin: 0 12px 0 0;
}
.rfp-award-address {
  display: block;
  width: 100%;
  max-width: 100%;
  height: 62px;
  border: 1px solid #dbe1ea;
  border-radius: 8px;
  padding: 8px 14px;
  background-color: #f7f9fc;
  font-size: 15px;
  line-height: 1.4;
  color: #12356b;
  cursor: default;
}
.rfp-award-address::placeholder {
  color: #9aa7bd;
}
.rfp-award-address[readonly] {
  background-color: #f7f9fc;
}
.rfp-award-address:disabled {
  cursor: not-allowed;
  background-color: #eef1f6;
}
/* Textareas */
.rfp-award-textarea-wrapper {
  position: relative;
  width: 100%;
}
.rfp-award-textarea {
  display: block;
  width: 100%;
  max-width: 100%;
  height: 112px;
  border: 1px solid #dbe1ea;
  border-radius: 8px;
  padding: 12px 14px 28px 14px;
  font-size: 15px;
  color: #12356b;
}
.rfp-award-textarea::placeholder {
  color: #9aa7bd;
}
.rfp-award-counter {
  position: absolute;
  right: 14px;
  bottom: 8px;
  font-size: 13px;
  color: #8a97ad;
}
.rfp-award-accept {
  display: flex;
  align-items: center;
  margin-top: 6px;
  padding: 14px 18px;
  border: 1px solid #dbe1ea;
  border-radius: 8px;
  background-color: #fafbfd;
  cursor: pointer;
}
.rfp-award-accept-on {
  border-color: #c3e9d1;
  background-color: #f0faf3;
}
.rfp-award-accept-off {
  cursor: not-allowed;
  opacity: 0.75;
}
.rfp-award-check {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 38px;
  height: 38px;
  border: 2px solid #c8cedb;
  border-radius: 8px;
  background-color: #ffffff;
}
.rfp-award-check-on {
  border-color: #16a34a;
  background-color: #16a34a;
}
.rfp-award-check-icon {
  color: #ffffff !important;
  font-size: 26px !important;
  width: 26px;
  min-width: 26px;
  height: 26px;
  margin: 0;
}
.rfp-award-check-sep {
  width: 1px;
  height: 34px;
  margin: 0 18px;
  background-color: #d5dbe7;
}
.rfp-award-check-text {
  font-size: 17px;
  font-weight: 600;
  color: #7b8aa5;
}
.rfp-award-accept-on .rfp-award-check-sep {
  background-color: #b6e3c5;
}
.rfp-award-accept-on .rfp-award-check-text {
  color: #16a34a;
}
.rfp-award-attachment {
  margin-top: 4px;
}
/* Footer */
.rfp-award-footer {
  display: flex;
  justify-content: flex-end;
  padding: 16px 28px;
  border-top: 1px solid #e4e8ef;
}
.rfp-award-cancel,
.rfp-award-submit {
  min-width: 140px;
  height: 46px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
}
.rfp-award-cancel {
  margin-right: 14px;
  border: 1px solid #c8cedb;
  background-color: #ffffff;
  color: #12356b;
}
.rfp-award-submit {
  border: none;
  background-color: #c2185b;
  color: #ffffff;
}
.rfp-award-submit:disabled {
  opacity: 0.55;
}
@media (max-width: 767px) {
  .rfp-award-grid {
    grid-template-columns: 1fr;
  }
  .rfp-award-full {
    grid-column: 1 / 2;
  }
}
</style>
